// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e5301c55","186":"afa55841","272":"b7d4a9a0","372":"105e0fd9","738":"5704e846","841":"2d783f84","851":"61937ad9","856":"3c2c1064"}[chunkId] + ".chunk.js";
};